import "react";
import { Text } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
//#region src/components/FormikFields/FormikText.tsx
var FormikText = (props) => {
	const form = useFormikContext();
	return /* @__PURE__ */ jsx(Field, {
		name: props.name,
		children: ({ field, meta }) => /* @__PURE__ */ jsx(Text, {
			...props,
			error: (meta.touched || !!form.submitCount) && meta.error,
			valid: (meta.touched || !!form.submitCount) && meta.value && !meta.error,
			...field,
			onBlur: (e) => {
				if (props.onBlur) props.onBlur(e);
				field.onBlur(e);
			},
			onChange: (e) => {
				if (props.onChange) props.onChange(e);
				field.onChange(e);
			}
		})
	});
};
//#endregion
export { FormikText };

//# sourceMappingURL=FormikText.js.map